import { Flex } from 'antd';

import { RingComplianceBulkValidateButton } from './ring-compliance-bulk-validate-button';
import { RingCompliancePrintReportsButton } from './ring-compliance-print-reports-button';

export const RingComplianceHeader = () => {
  return (
    <Flex gap={8}>
      <RingCompliancePrintReportsButton />
      <RingComplianceBulkValidateButton />
    </Flex>
  );
};
